import { cloneDeep, isEmpty } from 'lodash'
import { ORDER } from '.'
import { ORDER_ACTION_TEXT, ORDER_MODAL, ORDER_TYPE, categorizeGetListCatering } from '../../helpers'
import { MODAL } from '../Modal'
import apiService from '../apiService'

export const getListCateringByCompanyId = (companyId) => {
  return async (dispatch) => {
    try {
      const orderResponse = await apiService.get('rest/v1/getlist_catering2', { companyId })
      const companyOrderList = cloneDeep(orderResponse.data.list)
      
      if (orderResponse.status) {
        const allOrderByType = _categorizeAndPrepareOrderHashMap(companyOrderList)
        dispatch(_setAllOrdersToHashMap({ ...allOrderByType }))
      } else {
        dispatch(MODAL.action.openModalStatus(orderResponse))
      }
    } catch (error) {
      console.error('getListCateringByCompanyId Error :: ', error)
    }
  }
}

const _categorizeAndPrepareOrderHashMap = (companyOrderList) => {
  const orderByType = categorizeGetListCatering(companyOrderList)
  const allOrderByType = _prepareOrderHashMap(orderByType)

  return allOrderByType
}

export const setEditOrderHashMap = (orderId) => {
  return async (dispatch, getState) => {
    try {
      const cateringList = cloneDeep(getState().meetingReducer.cateringList)
      const equipmentList = cloneDeep(getState().meetingReducer.equipmentList)
      const allOrderList = [...cateringList, ...equipmentList]
      const previousOrder = allOrderList.find((elem) => elem.orderId === orderId)
      const previousOrderByType = categorizeGetListCatering(previousOrder.items)

      const orderReducer = cloneDeep(getState().orderReducer)

      const orderListByType = [
        orderReducer.currentDrinkHashMap,
        orderReducer.currentFoodHashMap,
        orderReducer.currentEquipmentHashMap,
      ]

      const _prevOrderByType = _overwriteOrderAmount(previousOrderByType, orderListByType)
      const orderWithPrevAmount = _prepareOrderHashMap(_prevOrderByType)

      dispatch(_setAllOrdersToHashMap({ ...orderWithPrevAmount }))
    } catch (error) {
      console.error('setEditOrderHashMap :: ', error)
    }
  }
}

const _prepareOrderHashMap = (hashMapByType) => {
  return {
    previousDrinkHashMap: hashMapByType[ORDER_TYPE.DRINK.VALUE] ? cloneDeep(hashMapByType[ORDER_TYPE.DRINK.VALUE]) : {},
    previousFoodHashMap: hashMapByType[ORDER_TYPE.FOOD.VALUE] ? cloneDeep(hashMapByType[ORDER_TYPE.FOOD.VALUE]) : {},
    previousEquipmentHashMap: hashMapByType[ORDER_TYPE.EQUIPMENT.VALUE] ? cloneDeep(hashMapByType[ORDER_TYPE.EQUIPMENT.VALUE]) : {},
    currentDrinkHashMap: hashMapByType[ORDER_TYPE.DRINK.VALUE] ? cloneDeep(hashMapByType[ORDER_TYPE.DRINK.VALUE]) : {},
    currentFoodHashMap: hashMapByType[ORDER_TYPE.FOOD.VALUE] ? cloneDeep(hashMapByType[ORDER_TYPE.FOOD.VALUE]) : {},
    currentEquipmentHashMap: hashMapByType[ORDER_TYPE.EQUIPMENT.VALUE] ? cloneDeep(hashMapByType[ORDER_TYPE.EQUIPMENT.VALUE]) : {},
  }
}

const _overwriteOrderAmount = (previousItemByType, orderListByType) => {
  const prevOrderList = [...orderListByType]

  for (const key in previousItemByType) {
    const itemListByType = Object.values(previousItemByType[key])

    itemListByType.forEach(({itemId, amount}) => {
      if (prevOrderList[key][itemId].itemId === itemId) {
        prevOrderList[key][itemId].amount = amount
      }
    })
  }

  const addedAmountOrderHashMap = { ...[...prevOrderList] }
  return addedAmountOrderHashMap
}

export const updateEditOrder = (selectedOrderTab, orderId) => {
  return async (dispatch) => {
    if (selectedOrderTab === ORDER_MODAL.VALUE.DRINK || selectedOrderTab === ORDER_MODAL.VALUE.FOOD) {
      return await dispatch(_updateEditCatering(orderId))
    } else if (selectedOrderTab === ORDER_MODAL.VALUE.EQUIPMENT) {
      return await dispatch(_updateEditEquipment(orderId))
    }
  }
}

const _updateEditCatering = (orderId) => {
  return async (dispatch, getState) => {
    const editedDrink = cloneDeep(getState().orderReducer.currentDrinkHashMap)
    const editedFood = cloneDeep(getState().orderReducer.currentFoodHashMap)
    const previousDrink = cloneDeep(getState().orderReducer.previousDrinkHashMap)
    const previousFood = cloneDeep(getState().orderReducer.previousFoodHashMap)

    const updatedDrink = Object.values(_prepareItemForUpdate(editedDrink, previousDrink))
    const updatedFood = Object.values(_prepareItemForUpdate(editedFood, previousFood))

    const updatedCatering = [...updatedDrink, ...updatedFood]

    return await _editOrder(orderId, updatedCatering)
  }
}

const _updateEditEquipment = (orderId) => {
  return async (dispatch, getState) => {
    const editedEquipment = cloneDeep(getState().orderReducer.currentEquipmentHashMap)
    const previousEquipment = cloneDeep(getState().orderReducer.previousEquipmentHashMap)

    const updatedEquipment = Object.values(_prepareItemForUpdate(editedEquipment, previousEquipment))

    return await _editOrder(orderId, updatedEquipment)
  }
}

const _editOrder = async (orderId, items) => {
  try {
    const data = items.filter((_item) => _item.amount > 0)
    if (data.length > 0) {
      return await apiService.patch(`rest/v2/order/${orderId}`, { items })
    }
    return { modalAskDeleteOrder: 'modalAskDeleteOrder' }
  } catch (error) {
    console.error('editOrder :: ', error)
  }
}

export const confirmOrder = (selectedOrderTab) => {
  return (dispatch, getState) => {
    const bookingId = getState().meetingReducer.bookingDetail.bookingId

    if (selectedOrderTab === ORDER_MODAL.VALUE.DRINK || selectedOrderTab === ORDER_MODAL.VALUE.FOOD) {
      return dispatch(_confirmCatering(bookingId))
    } else if (selectedOrderTab === ORDER_MODAL.VALUE.EQUIPMENT) {
      return dispatch(_confirmEquipment(bookingId))
    }
  }
}

export const clearConfirmOrder = () => {
  return (dispatch) => {
    dispatch(_setConfirmItems({ confirmItems: [] }))
  }
}

const _confirmCatering = (bookingId) => {
  return (dispatch, getState) => {
    const currentDrinkHashMap = cloneDeep(getState().orderReducer.currentDrinkHashMap)
    const currentFoodHashMap = cloneDeep(getState().orderReducer.currentFoodHashMap)

    const addedDrink = _prepareItemForAdd(currentDrinkHashMap)
    const addedFood = _prepareItemForAdd(currentFoodHashMap)

    const addedCatering = [...addedDrink, ...addedFood]

    if (isEmpty(addedCatering)) {
      return false
    }

    dispatch(_setConfirmItems({ ...{confirmItems: addedCatering} }))
    return true
  }
}

const _confirmEquipment = (bookingId) => {
  return (dispatch, getState) => {
    const currentEquipmentHashMap = cloneDeep(getState().orderReducer.currentEquipmentHashMap)

    const addedEquipment = _prepareItemForAdd(currentEquipmentHashMap)

    if (isEmpty(addedEquipment)) {
      return false
    }

    dispatch(_setConfirmItems({ confirmItems: addedEquipment }))
    return true
  }
}

export const createOrder = () => {
  return async (dispatch, getState) => {
    const { bookingId } = getState().meetingReducer.bookingDetail
    const items = getState().orderReducer.confirmItems

    const payload = {
      bookingId,
      items: [...items],
    }

    const response = await apiService.post(`rest/v2/order`, payload)

    return response
  }
}

export const deleteOrder = () => {
  return async (dispatch, getState) => {
    const orderId = getState().orderReducer.orderId

    // COMMENTS : this deletedReason is needed. if you guys update the "delete order api" to receive reason input you can delete below line and use that reason instead
    const payload = { deletedReason: 'deletedReason' }

    return await apiService.delete(`rest/v2/order/${orderId}`, payload)
  }
}

const _prepareItemForAdd = (currentOrderHashMap) => {
  const currentOrderList = Object.values({...currentOrderHashMap})
    .filter((item) => item.amount > 0)

  return currentOrderList
}

const _prepareItemForUpdate = (editedItem, prevItem) => {
  const updatedItem = {}

  for (const key in editedItem) {
    if (editedItem[key].amount !== 0) {
      updatedItem[key] = editedItem[key]
      continue
    }

    if (prevItem[key].amount > 0) {
      updatedItem[key] = editedItem[key]
    }
  }

  return updatedItem
}

export const orderIncrement = (itemId, itemType) => {
  return (dispatch) => {
    if (itemType === ORDER_TYPE.DRINK.VALUE) {
      dispatch(_drinkIncrement(itemId))
    } else if (itemType === ORDER_TYPE.FOOD.VALUE) {
      dispatch(_foodIncrement(itemId))
    } else if (itemType === ORDER_TYPE.EQUIPMENT.VALUE) {
      dispatch(_equipmentIncrement(itemId))
    } else {
      throw new Error ('wrong parameters')
    }
  }
}

const _drinkIncrement = (itemId) => {
  return (dispatch, getState) => {
    const currentDrinkHashMap = {...getState().orderReducer.currentDrinkHashMap}
    currentDrinkHashMap[itemId].amount += 1
    dispatch(_setCurrentDrinkHashMap({ currentDrinkHashMap }))
  }
}

const _foodIncrement = (itemId) => {
  return (dispatch, getState) => {
    const currentFoodHashMap = {...getState().orderReducer.currentFoodHashMap}
    currentFoodHashMap[itemId].amount += 1
    dispatch(_setCurrentFoodHashMap({ currentFoodHashMap }))
  }
}

const _equipmentIncrement = (itemId) => {
  return (dispatch, getState) => {
    const currentEquipmentHashMap = {...getState().orderReducer.currentEquipmentHashMap}
    currentEquipmentHashMap[itemId].amount += 1
    dispatch(_setCurrentEquipmentHashMap({ currentEquipmentHashMap }))
  }
}

export const orderDecrement = (itemId, itemType) => {
  return (dispatch) => {
    if (itemType === ORDER_TYPE.DRINK.VALUE) {
      dispatch(_drinkDecrement(itemId))
    } else if (itemType === ORDER_TYPE.FOOD.VALUE) {
      dispatch(_foodDecrement(itemId))
    } else if (itemType === ORDER_TYPE.EQUIPMENT.VALUE) {
      dispatch(_equipmentDecrement(itemId))
    } else {
      throw new Error ('wrong parameters')
    }
  }
}

const _drinkDecrement = (itemId) => {
  return (dispatch, getState) => {
    const currentDrinkHashMap = {...getState().orderReducer.currentDrinkHashMap}
    if (currentDrinkHashMap[itemId].amount > 0) {
      currentDrinkHashMap[itemId].amount -= 1
    }
    dispatch(_setCurrentDrinkHashMap({ currentDrinkHashMap }))
  }
}

const _foodDecrement = (itemId) => {
  return (dispatch, getState) => {
    const currentFoodHashMap = {...getState().orderReducer.currentFoodHashMap}
    if (currentFoodHashMap[itemId].amount > 0) {
      currentFoodHashMap[itemId].amount -= 1
    }
    dispatch(_setCurrentFoodHashMap({ currentFoodHashMap }))
  }
}

const _equipmentDecrement = (itemId) => {
  return (dispatch, getState) => {
    const currentEquipmentHashMap = {...getState().orderReducer.currentEquipmentHashMap}
    if (currentEquipmentHashMap[itemId].amount > 0) {
      currentEquipmentHashMap[itemId].amount -= 1
    }
    dispatch(_setCurrentEquipmentHashMap({ currentEquipmentHashMap }))
  }
}

export const resetOrderToPreviousValue = () => {
  return (dispatch) => {
    const {
      previousDrinkHashMap,
      previousFoodHashMap,
      previousEquipmentHashMap,
    } = dispatch(_getAllPreviousOrder())

    const allPreviousHashMap = {
      currentDrinkHashMap: previousDrinkHashMap,
      currentFoodHashMap: previousFoodHashMap,
      currentEquipmentHashMap: previousEquipmentHashMap,
    }

    const orderId = null

    dispatch(_setAllCurrentHashMap({ ...allPreviousHashMap, orderId }))
  }
}

export const resetOrderToInitialValue = () => {
  return (dispatch) => {
    const {
      previousDrinkHashMap,
      previousFoodHashMap,
      previousEquipmentHashMap,
    } = dispatch(_getAllPreviousOrder())

    const allPreviousItemHashMap = {
      ...previousDrinkHashMap,
      ...previousFoodHashMap,
      ...previousEquipmentHashMap,
    }
    
    for (const itemId in allPreviousItemHashMap) {
      allPreviousItemHashMap[itemId].amount = 0
    }

    const orderId = null

    const allOrderByType = _categorizeAndPrepareOrderHashMap(Object.values(allPreviousItemHashMap))
    dispatch(_setAllOrdersToHashMap({ ...allOrderByType, orderId }))
  }
}

const _getAllPreviousOrder = () => {
  return (_, getState) => {
    const previousDrinkHashMap = cloneDeep(getState().orderReducer.previousDrinkHashMap)
    const previousFoodHashMap = cloneDeep(getState().orderReducer.previousFoodHashMap)
    const previousEquipmentHashMap = cloneDeep(getState().orderReducer.previousEquipmentHashMap)

    return {
      previousDrinkHashMap,
      previousFoodHashMap,
      previousEquipmentHashMap,
    }
  }
}

export const setOrderId = (orderId) => {
  return (dispatch) => {
    dispatch({ type: ORDER.actionType.SET_ORDER_ID, data: orderId })
  }
}

export const clearOrderId = () => {
  return (dispatch) => {
    dispatch({ type: ORDER.actionType.SET_ORDER_ID, data: { orderId: null } })
  }
}

const _setAllOrdersToHashMap = (data) => {
  return {
    type: ORDER.actionType.SET_ALL_ORDER_HASH_MAP,
    data,
  }
}

const _setCurrentDrinkHashMap = (data) => {
  return {
    type: ORDER.actionType.SET_CURRENT_DRINK_HASH_MAP,
    data
  }
}

const _setCurrentFoodHashMap = (data) => {
  return {
    type: ORDER.actionType.SET_CURRENT_FOOD_HASH_MAP,
    data
  }
}

const _setCurrentEquipmentHashMap = (data) => {
  return {
    type: ORDER.actionType.SET_CURRENT_EQUIPMENT_HASH_MAP,
    data
  }
}

const _setAllCurrentHashMap = (data) => {
  return {
    type: ORDER.actionType.SET_ALL_CURRENT_HASH_MAP,
    data
  }
}

const _setConfirmItems = (data) => {
  return {
    type: ORDER.actionType.SET_CONFIRM_ITEMS,
    data
  }
}

export const setOrderActionText = (selectedTab, orderAction) => dispatch => {
  const orderActionSet = {...ORDER_ACTION_TEXT[selectedTab]}
  
  dispatch({
    type: ORDER.actionType.SET_ORDER_ACTION_TEXT,
    data: { orderActionText: orderActionSet[orderAction] },
  })
}

export const clearOrderActionText = () => dispatch => {
  dispatch({
    type: ORDER.actionType.SET_ORDER_ACTION_TEXT,
    data: { orderActionText: null }
  })
}

export const setIsEditOrder = (isEditOrder) => dispatch => {
  dispatch({
    type: ORDER.actionType.SET_IS_EDIT_ORDER,
    data: { isEditOrder }
  })
}

export const resetAllOrder = () => dispatch => {
  dispatch({
    type: ORDER.actionType.RESET_ALL_ORDER,
  })
}
